var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureCustodianship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 201,
    viewBox: "0 0 400 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_5285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.617188H400V200.617H0V0.617188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.99609,
    y: 192.348,
    width: 60,
    height: 13,
    transform: "rotate(-60 4.99609 192.348)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 159.617,
    width: 48,
    height: 13,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 172.617,
    width: 40,
    height: 13,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9961,
    y: 185.617,
    width: 53,
    height: 14,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.9961,
    cy: 131.617,
    r: 28,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4961 117.617V145.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4961 117.617V145.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4961 131.617H79.4961C81.9814 131.617 83.9961 129.602 83.9961 127.117C83.9961 124.632 81.9814 122.617 79.4961 122.617H72.4961V131.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9961 122.617H72.4961M72.4961 122.617H79.4961C81.9814 122.617 83.9961 124.632 83.9961 127.117V127.117C83.9961 129.602 81.9814 131.617 79.4961 131.617H72.4961V122.617Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4961 131.617H80.4961C82.9814 131.617 84.9961 133.632 84.9961 136.117C84.9961 138.602 82.9814 140.617 80.4961 140.617H72.4961V131.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9961 140.617H72.4961M72.4961 140.617H80.4961C82.9814 140.617 84.9961 138.602 84.9961 136.117V136.117C84.9961 133.632 82.9814 131.617 80.4961 131.617H72.4961V140.617Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.996 47.6172L296.996 183.617C296.996 192.454 289.833 199.617 280.996 199.617L268.996 199.617L268.996 47.6172L296.996 47.6172Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6.4 6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9961 63.6172C88.9961 54.7806 96.1595 47.6172 104.996 47.6172L268.996 47.6172L268.996 199.617L88.9961 199.617L88.9961 63.6172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 87.6172,
    width: 14,
    height: 72,
    rx: 7,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 97.6172,
    width: 14,
    height: 8,
    rx: 4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 141.617,
    width: 14,
    height: 8,
    rx: 4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 123.617,
    r: 44,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 123.617,
    r: 36,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.996 123.617H228.996",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.996 99.6172L204.996 147.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.996,
    cy: 119.617,
    r: 10,
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.996,
    cy: 123.617,
    r: 10,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.746 141.367H373.996C378 141.367 381.246 144.613 381.246 148.617V155.867H326.746V141.367Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.996,
    y: 152.617,
    width: 68,
    height: 48,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.746 168.617V167.867H393.996H373.996C369.164 167.867 365.246 171.785 365.246 176.617C365.246 181.45 369.164 185.367 373.996 185.367H393.996H394.746V184.617V168.617Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.996,
    cy: 176.617,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.996 11.6172H331.996C345.251 11.6172 355.996 22.3624 355.996 35.6172V121.617",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6.4 6.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.996,
    cy: 119.617,
    r: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.996,
    cy: 11.6172,
    r: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_5285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "white",
    transform: "translate(0 0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCustodianship);
export default __webpack_public_path__ + "static/media/secure_custodianship.b99994eceb921476d42cc8fd368370a3.svg";
export { ForwardRef as ReactComponent };